export const InfoItem = ({ icon, description }) => (
  <div className="post_item">
    <div className="post_item_icon">{icon}</div>
    <span className="post_item_description ">{description}</span>
  </div>
);
